import {Controller} from "@hotwired/stimulus";
import {AllCommunityModule, ModuleRegistry, createGrid, themeBalham, ClientSideRowModelModule} from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);

export default class extends Controller {

  static targets = ['element', "create", "update", "delete", "hitems", "updateCells", "removeCells"];

  static values = {
    headers: {type: Array, default: []},
    url: {type: String, default: undefined},
    skey: {type: String, default: ''},
    rowModel: {type: String, default: 'infinite'},
    totalCount: Number,
    rowHeight: Number,
    headerHeight: Number,
    originalTotalCount: Number,
    defaultFilterModel: Object,
    fitToTable: {type: Boolean, default: false},
    fromCustomApp: {type: Boolean, default: false},
    rows: {type: Array, default: []},
  }

  connect() {
    const jsonData = document.getElementById('filter-data').textContent
    this.filterData = JSON.parse(jsonData)
    let gridOptions = this.gridDataOptions();
    this.elementTarget.innerHTML = '';
    this.api = createGrid(this.elementTarget, gridOptions);
    if (this.fitToTableValue) {
      this.api.sizeColumnsToFit();
    }
    this.dataSource = {
      rowCount: this.totalCountValue, // behave as infinite scroll
      getRows: (params) => {
        console.log('asking for ' + params.startRow + ' to ' + params.endRow);
        if (params.startRow === 0 && params.endRow === 100 && params.sortModel.length === 0 && Object.keys(params.filterModel).length === 0) {
          let rowsThisPage = this.rowsValue;
          let lastRow = this.totalCountValue;
          params.successCallback(rowsThisPage, lastRow);
        } else {
          this.fetchData(params)
        }
      }
    }
    this.api.setGridOption('datasource', this.dataSource)
  }

  createTargetConnected(element) {
    let newRow = JSON.parse(element.dataset.rowValue)
    this.totalCountValue = this.totalCountValue + 1
    this.api.setRowCount(this.totalCountValue, true)
    this.rowsValue = [newRow].concat(this.rowsValue)
    this.api.refreshInfiniteCache()
  }

  updateTargetConnected(element) {
    let row = JSON.parse(element.dataset.rowValue)
    this.api.getRowNode(row.rowId).updateData(row)
  }

  deleteTargetConnected(element) {
    let rowId = element.dataset.rowValue
    this.rowsValue = this.rowsValue.filter(hash => hash.rowId !== rowId)
    this.api.refreshInfiniteCache()
  }

  updateCellsTargetConnected(element) {
    let parentElement = this.element.querySelector('[data-id="update-modal"]')
    parentElement.querySelector('[data-modal-target="modalBg"]').classList.add('hidden')
    parentElement.querySelector('[data-modal-target="modal"]').classList.add('hidden')
    let rows = JSON.parse(element.dataset.rowValue)
    rows.forEach(row => {
      let rowId = row.rowId;
      let rowNode = this.api.getRowNode(rowId);
      Object.entries(row).forEach(([colName, colValue]) => {
        if (colName !== 'rowId') {
          rowNode.setDataValue(colName, colValue)
        }
      });
      rowNode.setSelected(false)
    });
  }


  removeCellsTargetConnected(element) {
    let rows = JSON.parse(element.dataset.rowValue)
    rows.forEach(row => {
      let rowId = row.rowId;
      let rowNode = this.api.getRowNode(rowId);
      Object.entries(row).forEach(([colName, colValue]) => {
        if (colName !== 'rowId') {
          rowNode.setDataValue(colName, colValue)
        }
      });
      rowNode.setSelected(false)
    });
  }

  gridDataOptions() {

    let obj = {};
    obj['rowModelType'] = 'infinite';
    obj['pagination'] = true;
    obj['theme'] = themeBalham;
    obj['paginationPageSize'] = 100;

    obj['enableCellTextSelection'] = true;

    obj['paginationPageSizeSelector'] = false;
    obj['columnDefs'] = this.columnHeaders()
    obj['rowSelection'] = {mode: "multiRow", checkboxes: false, headerCheckbox: false, ctrlASelectsRows: true}
    if (this.headerHeightValue) {
      obj['headerHeight'] = this.headerHeightValue
    }
    if (this.rowHeightValue) {
      obj['rowHeight'] = this.rowHeightValue
    }
    if (this.filterData) {
      obj.onGridReady = (params) => {
        params.api.setFilterModel(this.filterData);
      };
    }

    obj.onFilterChanged = (params) => {
      if (Object.keys(params.api.getFilterModel()).length === 0) {
        document.getElementById('clear_filter').click()
      }
    }
    obj['domLayout'] = 'autoHeight';
    obj['getRowId'] = (params) => params.data.rowId
    return obj;
  }

  fetchData(params) {
    let url = this.urlValue || window.location.href
    let totalCount = this.totalCountValue
    let pageNumber = this.api.paginationGetCurrentPage() + 1
    if (Object.keys(params.filterModel).length > 0) {
      var agFilter = btoa(JSON.stringify(params.filterModel))
      if (url.includes('?')) {
        url += '&ag_filter=' + agFilter;
      } else {
        url += '?ag_filter=' + agFilter;
      }
      let filterElement = this.element.parentElement.querySelector('form > #ag_filter')
      if (filterElement) {
        filterElement.value = agFilter
      }
    }
    if (params.sortModel.length > 0) {
      var agSort = btoa(JSON.stringify(params.sortModel))
      if (url.includes('?')) {
        url += '&ag_sort=' + agSort;
      } else {
        url += '?ag_sort=' + agSort;
      }
      let sortElement = this.element.parentElement.querySelector('form > #ag_sort')
      if (sortElement) {
        sortElement.value = agSort
      }
    }
    if (url.includes('?')) {
      url += '&page=' + pageNumber;
    } else {
      url += '?page=' + pageNumber;
    }
    let uploadElement = this.element.querySelector('[data-id="data-upload"]');
    if (uploadElement) {
      let uploadLink = uploadElement.href;
      const urlParts = uploadLink.split('?');
      const baseUrl = urlParts[0];
      const searchParams = new URLSearchParams(urlParts[1] || '');
      searchParams.set('ag_sort', agSort || '');
      searchParams.set('ag_filter', agFilter || '');
      const updatedUrl = baseUrl + '?' + searchParams.toString();
      uploadElement.href = updatedUrl;
    }

    fetch(url, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    }).then((response) => response.json()).then(result => {
      let data = result.row_data
      let lastRow = result.total_count || totalCount;
      params.successCallback(data, lastRow);
    })
  }

  columnHeaders() {
    let headers = this.headersValue;
    headers.forEach((item, index) => {
      this.parseObject(item)
    });
    return headers;
  }

  parseObject(item) {
    Object.keys(item).forEach((key) => {
      if (typeof (item[key]) === 'string' && item[key].includes('RAILS_JS')) {
        let matches = item[key].match(/RAILS_JS:((?!RAILS_JS:).*?):RAILS_JS_END/);
        if (matches && matches[1]) {
          item[key] = new Function('return (' + atob(matches[1]) + ')')();
        }
      }
    })
    if (item['children'] !== undefined) {
      item['children'].forEach((child, index) => {
        this.parseObject(child)
      });
    }
  }

  checkAll() {
    const gridApi = this.api;
    const renderedNodes = gridApi.getRenderedNodes();
    const displayedRowCount = renderedNodes ? renderedNodes.length : 0
    for (let i = 0; i < displayedRowCount; i++) {
      const node = gridApi.getDisplayedRowAtIndex(i);
      if (!node.isSelected()) {
        node.setSelected(true);
      }
    }
  }

  uncheckAll() {
    const gridApi = this.api;
    const renderedNodes = gridApi.getRenderedNodes();
    const displayedRowCount = renderedNodes ? renderedNodes.length : 0
    for (let i = 0; i < displayedRowCount; i++) {
      const node = gridApi.getDisplayedRowAtIndex(i);
      if (node.isSelected()) {
        node.setSelected(false);
      }
    }
  }

  deleteSelected(event) {
    event.preventDefault();
    const gridApi = this.api
    const selectedNodes = gridApi.getSelectedNodes()
    const selectedIds = selectedNodes.map(node => node.data.rowId)
    if (selectedIds.length > 0) {
      if (window.confirm("Are you sure you want to delete the rows?")) {
        var url = event.target.dataset.url
        let token = document.querySelector('meta[name="csrf-token"]').content;
        fetch(url, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({row_ids: selectedIds})
        }).then(response => {
          if (response.ok) {
            window.location.reload();
          } else {
            console.error("Delete request failed");
          }
        })
            .catch(error => {
              console.error("Error during delete request", error);
            });
      }

    } else {
      alert('Please select any rows');
    }


  }

  removeSelected(event) {
    event.preventDefault
    const gridApi = this.api
    const selectedNodes = gridApi.getSelectedNodes()
    const selectedIds = selectedNodes.map(node => node.data.rowId)
    if (selectedIds.length > 0) {
      if (window.confirm("Are you sure you want to delete the rows?")) {
        var url = event.target.dataset.url
        let token = document.querySelector('meta[name="csrf-token"]').content;
        fetch(url, {
          method: 'DELETE',
          headers: {
            'X-CSRF-Token': token,
            'Content-Type': 'application/json',
            'Accept': 'text/vnd.turbo-stream.html'
          },
          body: JSON.stringify({row_ids: selectedIds})
        }).then((response) => response.text())
            .then((html) => {
              Turbo.renderStreamMessage(html)
            })
      }

    } else {
      alert('Please select any rows');
    }

  }

  updateSelected(event) {
    const gridApi = this.api
    const selectedNodes = gridApi.getSelectedNodes()
    const selectedIds = selectedNodes.map(node => node.data.rowId)
    let parentElement = this.element.querySelector('[data-id="update-modal"]')
    let form = parentElement.querySelector("form")
    const textInputs = form.querySelectorAll('[data-type="text"],select')
    textInputs.forEach(input => {
      if (input.tagName.toLowerCase() === 'input') {
        input.value = ''
      } else if (input.tagName.toLowerCase() === 'select') {

      }
    })
    if (selectedIds.length > 0) {
      if (selectedIds.length === 1) {
        let targetRowId = selectedIds[0]
        const selectedRow = selectedNodes.find(node => node.data.rowId === targetRowId)
        textInputs.forEach(input => {
          if (input.tagName.toLowerCase() === 'input') {
            if (input.dataset.sub === 'date') {
              const selectedValue = selectedRow.data[input.dataset.id]
              const dateInstance = flatpickr(input, {
                dateFormat: 'd M Y',
              })
              dateInstance.setDate(selectedValue)
            } else {
              input.value = selectedRow.data[input.dataset.id] !== undefined ? selectedRow.data[input.dataset.id] : ""
            }
          } else if (input.tagName.toLowerCase() === 'select') {
            const tomSelectInstance = input.tomselect
            const selectedValue = selectedRow.data[input.dataset.id]
            selectedValue.forEach(value => {
              tomSelectInstance.addOption({value: value, text: value});
            })
            tomSelectInstance.setValue(selectedValue)

          }
        })
        parentElement.querySelector('[data-id="row-warning"]').classList.add('hidden')
      } else {
        parentElement.querySelector('[data-id="row-warning"]').classList.remove('hidden')
      }

      const actionUrl = new URL(form.action)
      actionUrl.searchParams.set('ledger_entry_source_ids', selectedIds)
      form.action = actionUrl.toString()
      parentElement.querySelector('[data-modal-target="modalBg"]').classList.remove('hidden')
      parentElement.querySelector('[data-modal-target="modal"]').classList.remove('hidden')
    } else {
      alert('Please select any rows')
    }
  }

  toggleColumn() {
    let hitems = this.hitemsTargets.map((x, index) => {
      if (x.checked) {
        return x.dataset['itemId'];
      }
    }).filter(n => n)
    let columns = this.columnHeaders().filter((col) => hitems.includes(col['colId'])).map((x, index) => {
      x['hide'] = false
      return x;
    })
    if (columns.length > 0) {
      this.api.setGridOption('columnDefs', columns)
    } else {
      this.api.setGridOption('columnDefs', this.columnHeaders())
    }
  }
}
